import { render, staticRenderFns } from "./TreeViewItem.vue?vue&type=template&id=742bc4cc"
import script from "./TreeViewItem.vue?vue&type=script&lang=ts"
export * from "./TreeViewItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports